import {
  ActionIcon,
  Badge,
  Button,
  Group,
  Stack,
  Text,
  Tooltip
} from '@mantine/core'
import { IconPencil, IconPlus } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'

type MqttTopicListProps = {
  topics: string[]
  onEdit: () => void
  onAdd: () => void
}
export const MqttTopicList = ({
  topics,
  onEdit,
  onAdd
}: MqttTopicListProps) => {
  const hasTopics = topics.length > 0

  return (
    <Stack gap={4} align="start">
      <Text size="sm" fw={600}>
        <FormattedMessage id="integrations.mqtt.topics" />
      </Text>

      {hasTopics && (
        <Group wrap="nowrap" gap="xs" align="start">
          <Group gap={4}>
            {topics.map((topic) => (
              <Badge
                key={topic}
                size="sm"
                color="blue"
                styles={{
                  root: {
                    textTransform: 'none' // prevent uppercase
                  }
                }}
              >
                {topic}
              </Badge>
            ))}
          </Group>

          <Tooltip
            label={<FormattedMessage id="integrations.mqtt.topics.edit" />}
          >
            <ActionIcon variant="subtle" size="xs" radius="xl" onClick={onEdit}>
              <IconPencil style={{ width: '80%', height: '80%' }} />
            </ActionIcon>
          </Tooltip>
        </Group>
      )}

      {!hasTopics && (
        <Button
          size="compact-xs"
          leftSection={<IconPlus size={14} />}
          onClick={onAdd}
        >
          <FormattedMessage id="integrations.mqtt.topics.add" />
        </Button>
      )}
    </Stack>
  )
}
